import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ParentItemProviderService } from '@app/shared';
import {
  log,
  NtapCommonComponent,
  NtapGlobalConstants,
  UIComponents,
  Util
} from '@ntap/core';

@Component({
  selector: 'app-objekti-fizickog-objekta',
  templateUrl: './objekti-fizickog-objekta.component.html',
  styleUrls: ['./objekti-fizickog-objekta.component.scss'],
  providers: [ParentItemProviderService]
})
export class ObjektiFizickogObjektaListComponent
  extends NtapCommonComponent
  implements OnInit, OnDestroy
{
  INIT_COMP_ID = UIComponents.LISTVIEW;

  currentListViewName: string;
  currentListViewState: object | null = null;
  currentListViewStateFilter: object = {};

  constructor(
    protected route: ActivatedRoute,
    protected parentItemProvider: ParentItemProviderService
  ) {
    super();
  }

  ngOnInit() {
    this.addSubscription(
      this.parentItemProvider.parentItem$.subscribe((parentItem) => {
        log('param change');
        this.changeView('fizicki_objekti_fizickog_objekta', parentItem);
      })
    );
  }

  changeView(viewName: string, parentItem: any) {
    log(`CHANGE NEW view: ${viewName}`);
    this.currentListViewName = viewName;
    this.currentListViewState = {
      $parentId:
        parentItem[
          Util.getFullAttrName(
            parentItem[NtapGlobalConstants.ATTR_$mainType],
            NtapGlobalConstants.ATTR_id
          )
        ],
      $itemType: 'en~fizicki_objekt',
      $parentType: 'en~fizicki_objekt',
      $parent: parentItem
    };
    this.currentListViewStateFilter = {};
  }
}
